import { createAsyncThunk } from '@reduxjs/toolkit';
import { Creature } from './entities';

// Starter bundle for MINI-2 — CC0 art dropped in public/creatures.
export const DEFAULT_CREATURES = [
    { name: 'Wolf', src: `${process.env.PUBLIC_URL}/creatures/Wolf.jpg` },
    { name: 'Goblin', src: `${process.env.PUBLIC_URL}/creatures/Goblin.jpg` },
];

// Mirrors the drop-to-data-URL conversion in SheetView.js so bundled
// creatures print reliably (Electron's print window loads a temp file with
// no access to /creatures, so a relative src won't resolve there).
function loadCreatureData({ name, src }) {
    return fetch(src)
        .then(r => r.blob())
        .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        }))
        .then(dataUrl => new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = function () {
                resolve({
                    name,
                    src: dataUrl,
                    srcWidth: this.width,
                    srcHeight: this.height,
                    size: 1,
                    heightRatio: this.height / this.width,
                });
            };
            img.onerror = () => reject(new Error(`Failed to load default creature image: ${name}`));
            img.src = dataUrl;
        }));
}

export const seedDefaultCreatures = createAsyncThunk(
    'Creature/seedDefaults',
    async (_, { getState, dispatch }) => {
        const existing = Creature.selectors.selectAll(getState().creatures);
        if (existing.length > 0) return;

        for (const defaultCreature of DEFAULT_CREATURES) {
            const data = await loadCreatureData(defaultCreature);
            await dispatch(Creature.actions.createEntityAsync(data));
        }
    }
);
